module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/bg2-7dd5899182814ed8acf8ab3deb604e54.jpg";